import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M4.179 15.513a1 1 0 0 1 .236-.372L18.294 1.292a1 1 0 0 1 1.413 0l2 2a1 1 0 0 1 0 1.415l-13.88 13.88a1 1 0 0 1-.369.234l-3.12 1.12a1 1 0 0 1-1.28-1.276l1.12-3.152Zm.942.335L16.644 4.351l2.003 2.003L7.12 17.88 4 19l1.121-3.152ZM19.354 5.647l-2.002-2.002L19 2l2 2-1.646 1.647Z"
    />
    <path d="M2.5 21a.5.5 0 0 0 0 1h19a.5.5 0 0 0 0-1h-19Z" />
  </IconWrapper>
)

export default EditIconMedium
